import React from "react"
import {
  CSMX_DSG,
  CSMX_MRP,
  CSMX_RGKS_PSN_PLG_FT,
  CSMX_RGKS_PSN_PLG_HD,
  CSMX_RGKS_PSN_PLG_IGD,
  CSMX_RGKS_PSN_PLG_LO,
  CSMX_RGKS_PSN_PLG_LT,
  CSMX_RGKS_PSN_PLG_RAJAL,
  CSMX_RGKS_PSN_PLG_RANAP,
} from "App/constants"
import {
  DigitalSign,
  Fisioterapi,
  LaporanOperasi,
  LaporanTindakan,
  MappingRikjangProsedur,
  RingkasanPasienPulangIGD,
  RingkasanPasienPulangRawatInap,
  RingkasanPasienPulangRawatJalan,
  RingkasanPasienPulangHemodialisa,
} from "../WrapperLazyExport"

export const menuCasemix = {
  [CSMX_RGKS_PSN_PLG_RAJAL]: <RingkasanPasienPulangRawatJalan />,
  [CSMX_RGKS_PSN_PLG_RANAP]: <RingkasanPasienPulangRawatInap />,
  [CSMX_RGKS_PSN_PLG_HD]: <RingkasanPasienPulangHemodialisa />,

  [CSMX_RGKS_PSN_PLG_IGD]: <RingkasanPasienPulangIGD />,
  [CSMX_RGKS_PSN_PLG_LO]: <LaporanOperasi />,
  [CSMX_RGKS_PSN_PLG_FT]: <Fisioterapi />,
  [CSMX_RGKS_PSN_PLG_LT]: <LaporanTindakan />,

  [CSMX_MRP]: <MappingRikjangProsedur />,

  [CSMX_DSG]: <DigitalSign />,
}
